import React, { useEffect } from "react";
import Problems from "./problems/Problems";
import { getCurrentProfile } from "../actions/profile";
import { connect } from "react-redux";

const Dashboard = ({ getCurrentProfile }) => {
  useEffect(() => {
    getCurrentProfile();
  }, [getCurrentProfile]);

  return (
    <div className='container-fluid'>
      <div className='row '>
        <div className='col-10 mx-auto'>
          <h2
            className='tag mt-2'
            style={{
              fontFamily: "Trocchi",
              fontWeight: "normal",
              lineHeight: "48px",
              fontSize: "35px",
            }}
          >
            All Challenges
          </h2>
          <div className='row'>
            <div className='col-md-10 col-sm-12 mx-auto problemContainer'>
              {/* add content here */}
              <Problems />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { getCurrentProfile })(Dashboard);
